import { post } from 'lib/utils/axiosFetcher';

export const hcpRegistration = async (data: any) => {
  try {
    const response = await post('/HCP/AddHCPRegistration', { ...data });
    return response;
  } catch (error) {
    // Handle error if needed
    console.error('Error while add or update Register details', error);
  }
};

export const callDapApiSendEmail = async (payload: any) => {
  try {
    await post('/Send/AddContactsToHCPMailingList', payload);
  } catch (error) {
    console.error('Error calling /Send/AddContactsToHCPMailingList');
    console.error(error);
  }
};
